import {
  CircleAlert,
  CircleCheck,
  Clock,
  Loader2,
  RefreshCcw,
} from "lucide-react";
import React from "react";
import { TemplateReportStatus } from "./TemplateReportSelector";

export const ReportStatusIcon = ({
  status,
  onRegenerate,
  disableRegenerate = false,
}: {
  status: TemplateReportStatus;
  onRegenerate: () => void;
  disableRegenerate?: boolean;
}) => {
  const handleRegenerate = (e: React.PointerEvent<HTMLButtonElement>) => {
    if (disableRegenerate) return;
    e.preventDefault();
    e.stopPropagation();
    onRegenerate();
  };

  return (
    <div>
      {status === "pending" && (
        <div className="size-5 bg-muted rounded-full flex justify-center items-center">
          <Clock className="size-3 text-muted-foreground" />
        </div>
      )}
      {status === "inProgress" && (
        <div className="size-5 bg-muted rounded-full flex justify-center items-center">
          <Loader2 className="size-3 animate-spin text-muted-foreground" />
        </div>
      )}
      {status === "completed" && !disableRegenerate && (
        <button
          onPointerDown={handleRegenerate}
          className="group size-5 bg-green-500 hover:bg-blue-600 rounded-full flex justify-center items-center"
        >
          <CircleCheck className="size-3 text-white group-hover:hidden" />
          <RefreshCcw className="size-3 text-white hidden group-hover:block" />
        </button>
      )}
      {status === "failed" && !disableRegenerate && (
        <button
          onPointerDown={handleRegenerate}
          className="group size-5 bg-red-500 hover:bg-blue-600 rounded-full flex justify-center items-center"
        >
          <CircleAlert className="size-3 text-white group-hover:hidden" />
          <RefreshCcw className="size-3 text-white hidden group-hover:block" />
        </button>
      )}
    </div>
  );
};
